import React, { useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import Modal, { IModalChildProps } from '../../../common/modal';
import { IOrderDetails } from '../../../../models/order';
import './modal-styles.css';
import { RootState } from '../../../../store';
import { connect } from 'react-redux';
import { updateBillTo, loadOrder } from '../../../../store/order/order-actions';
import { IAccount } from '../../../../models/company-account';
import { setIsBusy } from '../../../../store/api/api-status-action';
import { gaEvent } from '../../../../hooks/ga-hook';
interface ICancelModal extends IModalChildProps {
    order: IOrderDetails;
    updatedBillTo: IAccount;
    updateBillTo: (updatedBillTo: IAccount) => Promise<void>;
    loadOrder: (orderNumber: string) => Promise<void>;
    setIsBusy: (isBusy: boolean) => Promise<void>;
}

const UpdatedBillingModal = ({
    onAccept,
    onClose,
    order,
    updatedBillTo,
    updateBillTo,
    loadOrder,
    setIsBusy,
}: ICancelModal) => {
    const intl = useIntl();
    const [confirmed, setConfirmed] = useState(false);

    const onConfirm = () => {
        setConfirmed(true);
    };
    const sendShippingChange = () => {
        gaEvent(
            'Estore_Order_Updates',
            'BillTo_Modal_Update',
            updatedBillTo.accountNumber
        );

        setIsBusy(true);
        updateBillTo(updatedBillTo).then(() => {
            loadOrder(order.orderNumber).then(() => {
                setIsBusy(false);
            });
        });
        onClose();
    };

    return (
        <>
            {updatedBillTo && (
                <Modal>
                    <>
                        <div className="modal-header">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                id="closeModalConfirmBilling"
                                aria-label={intl.formatMessage({ id: 'Close' })}
                                onClick={onClose}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {confirmed ? (
                            <>
                                <p className="text-center">
                                    <span className="fa fa-check icon-green"></span>
                                    <strong>
                                        Billing Address successfully changed
                                    </strong>
                                </p>
                            </>
                        ) : (
                            <>
                                <p className="text-center">
                                    <strong>
                                        Are you sure you want to change your
                                        billing address?
                                    </strong>
                                    <br />
                                    changing your billing address may affect
                                    pricing of your items.
                                    <br />
                                </p>
                            </>
                        )}

                        <div className="modal-footer">
                            {confirmed ? (
                                <button
                                    className="btn btn-info"
                                    id="closeButtonModalConfirmBilling"
                                    onClick={sendShippingChange}
                                >
                                    <FormattedMessage
                                        id="shipping_method_confirmed "
                                        defaultMessage="Close"
                                    />
                                </button>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        id="cancelButtonModalConfirmBilling"
                                        className="btn btn-default"
                                        onClick={onClose}
                                    >
                                        <FormattedMessage
                                            id="Cancel"
                                            defaultMessage="Cancel"
                                        />
                                    </button>
                                    <button
                                        className="btn btn-info"
                                        id="confirmButtonModalConfirmBilling"
                                        onClick={onConfirm}
                                    >
                                        <FormattedMessage
                                            id="Cancel_Confirm"
                                            defaultMessage="Save Changes"
                                        />
                                    </button>
                                </>
                            )}
                        </div>
                    </>
                </Modal>
            )}
        </>
    );
};
const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {
    updateBillTo,
    loadOrder,
    setIsBusy,
};

const UpdatedBillingModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdatedBillingModal);

export default UpdatedBillingModalContainer;
